import React from 'react';
import PatientQueue from './PatientQueue';

const UrgentQueueCallBack = () =>
	<PatientQueue
		showQueueCount
		patientNameColumn
		providerDetailColumn
		timeBilledColumn
		urgentColumn
		todoItemColumn
		statusColumn
		showFilters
		showProgramTypeFilter
        showScheduleCallFilter
		chartColumn
		lastWorkedByColumn
		lastOutCallColumn
		callAttemptsCol
		showSort
		sortOptions={[
			{
				'name': 'Last Called Ascending',
				'key': 'lastOutCallTs&dir=asc',
			},
			{
				'name': 'Last Called Descending',
				'key': 'lastOutCallTs&dir=desc',
			}
		]}
		page
		queue="urgentCallBack"
		endpoint="Urgent?typesToInclude=11"
		label="Urgent - Call Back"
	/>;

export default UrgentQueueCallBack;
